const manganeseData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133793/assets/data-reports/price-assessments/benchmarkminerals_Charts_and_graphs_about_Lithium_photorealisti_411f98f3-72b8-4395-8060-03315a91ee2f_tjmrku.png',
  forecastBrochureFile: {
    EnvKey: 'forecastBrochureManganeseFilePdfID',
    file_name: 'Manganese Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Benchmark’s Manganese Sulphate Market Outlook service provides a detailed assessment of supply, demand and prices and is updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Asset-level insights:</strong> Supply analysis broken down by asset with results presented to show market dynamics.',
          '<strong>Plant by Plant:</strong> Granular review of processed materials by operation outside of China, including material flows to processing facilities within China.',
          '<strong>Demand Analysis:</strong> Manganese demand from lithium-ion batteries by category and regional end-use sector, including assessment of short-term market movements.',
          '<strong>Price Forecast:</strong> HPMSM prices on an Ex-Works China basis US$/t Real 2022 out to 2030.',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1692135894/assets/forecasts/manganese/Benchmark_Minerals_mining_mine_pit_big_sky_tones_of_yellow_and__88696925-b194-4290-b5ef-e38c6b1fd55d_1_u0icth.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1692135893/assets/forecasts/manganese/Benchmark_Minerals_black_coal_rock_in_the_close_tones_of_yellow_73b78eab-62ce-4b23-b7d5-8523a66b1019_1_br0pcc.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1692135893/assets/forecasts/manganese/image_287_1_aoiz82.png',
        alt: 'Synthetic Graphite Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1692135894/assets/forecasts/manganese/Benchmark_Minerals_Data_on_a_large_screen_charts_graphs_visual__5487d82e-d2cb-465d-a255-4550b756a463_1_ofolh7.png',
      title:
        'Benchmark’s Manganese Sulphate Market Outlook service features detailed data and analysis out to 2030:',
      descriptions: [
        {
          subtitle: '',
          items: [
            '<strong>Market outlook:</strong> Compare manganese sulphate market outlooks by raw material and processed product for a thorough view of the market.',
            '<strong>Demand drivers:</strong> End-use demand broken down by specific end-use out to 2030.',
            '<strong>ESG insights:</strong> explore the ESG metrics that need to be considered when evaluating future sources of manganese sulphate supply and demand.',
            '<strong>Regional perspectives:</strong> Examine processed manganese sulphate supply dynamics on a regional and asset basis.',
            '<strong>Developments:</strong> Track key investments, partnerships, and announcements over each quarter',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1692135894/assets/forecasts/manganese/Benchmark_Minerals_Data_on_a_large_screen_charts_graphs_visual__eea298ec-22ad-49d5-b569-5f3b50133cca_1_krfvu1.png',
      title:
        'You will receive full, unrestricted access to the data presented in Benchmark’s Manganese Sulphate Market Outlook service:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong>  downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in excel and pdf format',
          ],
        },
      ],
    },
  },
}
export default manganeseData
